import { Box, Stack, Typography } from "@mui/material";
import { AccountScoreLevelDefinition } from "../../../api/psc";

export default function AccountScoreProgressItem(props: {
    item: AccountScoreLevelDefinition;
    progress: number;
    colors: {
        first: string;
        second: string;
    };
}) {
    return (
        <>
            <Stack alignItems="center" spacing={2} flexGrow={1}>
                <Typography>{props.item.displayName}</Typography>

                <Box
                    sx={{
                        height: "8px",
                        bgcolor: "#CCC",
                        width: "100%",
                        borderRadius: "4px",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        sx={{
                            height: "8px",
                            background: `linear-gradient(to right, ${props.colors.first}, ${props.colors.second})`,
                            width: `${props.progress}%`,
                            borderRadius: "4px",
                            position: "absolute",
                        }}
                    />
                </Box>
            </Stack>
        </>
    );
}
